import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
  UncontrolledTooltip,
  CardSubtitle,
} from "reactstrap";
import ReactTable from "react-table";
import classNames from "classnames";
import { connect } from "react-redux";
import { get } from "lodash";
import "./redux/trasferimenti.reducer";
import TrasferimentiCreateComponent from "./components/trasferimenti.create.component";
import TrasferimentiUpdateComponent from "./components/trasferimenti.update.component";
import Fade from "react-reveal/Fade";
import ReactBSAlert from "react-bootstrap-sweetalert";
import _ from "lodash";
import {
  readedAll,
  requestDelete,
  deleted,
  deleteError,
} from "./redux/trasferimenti.actions";
import GraphqlClient from "../../client/graphql.client";
import store from "../../store/store";

class TrasferimentiComponent extends Component {
  state = {
    data: [],
    articoli: [],
    magazzini: [],
    loading: false,
    showCreateModal: false,
    showUpdateModal: false,
    selectedRecordForUpdate: {},
    showDeleteAlert: false,
    selectedRecordForDelete: {},
  };

  caricaTrasferimenti = async () => {
    try {
      const response = await GraphqlClient.ottieniTrasferimenti();

      store.dispatch(readedAll(response.ottieniTrasferimenti)); 
    } catch (e) {
      console.log("Impossibile caricare i dati", e);
    }
  };

  caricaArticoli = async () => {
    try {
      this.state.articoli = await GraphqlClient.ottieniArticoli();
       
    } catch (e) {
      console.log("Impossibile caricare i dati", e);
    }

  };
  caricaMagazzini = async () => {
    try {
      this.state.magazzini = await GraphqlClient.ottieniMagazzini();
       
    } catch (e) {
      console.log("Impossibile caricare i dati", e);
    }

  };

  componentDidMount() {
    this.caricaTrasferimenti();
    this.caricaArticoli();
    this.caricaMagazzini();
  }

  toggleShowCreateModal = () => {
    this.setState({
      showCreateModal: !this.state.showCreateModal,
    });
  };

  toggleShowUpdateModal = (record) => {
    this.setState({
      showUpdateModal: !this.state.showUpdateModal,
      selectedRecordForUpdate: record,
    });
    this.caricaTrasferimenti();
  };
  
  elimina = async () => {
    try {
      this.toggleDeleteAlert(this.state.selectedRecordForDelete);
      store.dispatch(requestDelete(this.state.selectedRecordForDelete.ID));
      await GraphqlClient.eliminaTrasferimento({
        id: this.state.selectedRecordForDelete.ID,
      });
      store.dispatch(deleted({ id: this.state.selectedRecordForDelete.ID })); // scommentare per abilitare redux: al posto di res.getDpiArticles mettere l'oggetto con i dati
    } catch (e) {
      console.log("Impossibile eliminare il record", e);
      store.dispatch(deleteError(this.state.selectedRecordForDelete.ID));
    }
    this.caricaTrasferimenti();
  };

  toggleDeleteAlert = (record) =>
    this.setState({
      showDeleteAlert: !this.state.showDeleteAlert,
      selectedRecordForDelete: record,
    });

  actions = (cellInfo) => (
    <div className="actions-right">
      {get(cellInfo, "original._deleting", false) ? (
        <i className="fa fa-spin fa-spinner" />
      ) : null}
      <Button
        color="warning"
        size="sm"
        onClick={() => this.toggleShowUpdateModal(cellInfo.original)}
        className={classNames("btn-icon btn-link like")}
      >
        <i className="tim-icons icon-pencil" />
      </Button>{" "}
      <Button
        color="danger"
        size="sm"
        onClick={() => this.toggleDeleteAlert(cellInfo.original)}
        className={classNames("btn-icon btn-link like")}
      >
        <i className="tim-icons icon-simple-remove" />
      </Button>{" "}
    </div>
  );

  render() {
    return (
      <>
        {this.state.showDeleteAlert ? (
          <ReactBSAlert
            warning
            style={{ display: "block" }}
            title="Confermare l'eliminazione ?"
            onConfirm={() => this.elimina()}
            onCancel={() => this.toggleDeleteAlert()}
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            confirmBtnText="Si"
            cancelBtnText="No"
            showCancel
            btnSize=""
          >
            Stai per eliminare in modo definitivo:{" "}
            {_.get(this.state, "selectedRecordForDelete.ID", "")}
          </ReactBSAlert>
        ) : null}
        {
          <TrasferimentiCreateComponent
            show={this.state.showCreateModal}
            toggle={this.toggleShowCreateModal}
            articoli={this.state.articoli}
            magazzini={this.state.magazzini}
          />
        }

        {this.state.showUpdateModal ? (
          <TrasferimentiUpdateComponent
            data={this.state.selectedRecordForUpdate}
            toggle={this.toggleShowUpdateModal}
            articoli={this.state.articoli}
            magazzini={this.state.magazzini}
          />
        ) : null}

        {/*Contenuto pagina*/}
        <div className="content">
          <Row>
            <Col xs={12} md={12}>
              <Card>
                <CardBody>
                  {/*Filtri*/}
                  <Row>
                    <Col className="mr-auto">
                      <button
                        className="btn btn-primary "
                        id="nuovoModal"
                        onClick={() => this.toggleShowCreateModal()}
                      >
                        <i className="tim-icons icon-simple-add" />
                        Nuovo
                      </button>
                      <UncontrolledTooltip
                        placement="bottom"
                        target="nuovoModal"
                        delay={0}
                      >
                        Crea un nuovo articolo
                        <br /> ( Hotkey F11)
                      </UncontrolledTooltip>
                    </Col>
                    <Col className="d-flex justify-content-end">
                      <button
                        id="refresh"
                        onClick={() => {
                          this.caricaTrasferimenti();
                        }}
                        className="btn btn-primary btn-fab btn-icon "
                      >
                        <i className="tim-icons icon-refresh-01"></i>
                      </button>
                      <UncontrolledTooltip
                        placement="bottom"
                        target="refresh"
                        delay={0}
                      >
                        Ricarica i dati
                      </UncontrolledTooltip>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            <Col xs={12} md={12}>
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Lista trasferimenti</CardTitle>
                  <Fade when={this.props.loading}>
                    <CardSubtitle>
                      Caricamento in corso{" "}
                      <i className="fa fa-spin fa-spinner" />
                    </CardSubtitle>
                  </Fade>
                </CardHeader>
                <CardBody>
                  <ReactTable
                    data={this.props.data}
                    filterable
                    resizable={false}
                    columns={[
                      //{ Header: "id", accessor: "ID" },
                      { Header: "articolo", accessor: "descrizioneArticolo" },
                      { Header: "quantita", accessor: "quantita" },
                      { Header: "magazzino Partenza", accessor: "desMagazzinoPartenza" },
                      { Header: "magazzino Arrivo", accessor: "desMagazzinoArrivo" },
                      {
                        Header: "Azioni",
                        Cell: this.actions,
                        sortable: false,
                        filterable: false,
                        show: !this.props.readOnly,
                      },
                    ]}
                    defaultPageSize={10}
                    showPaginationBottom={true}
                    className="-striped -highlight"
                    nextText={"Avanti"}
                    previousText={"Indietro"}
                    pageText={"Pagina"}
                    ofText={"di"}
                    rowsText={"elementi"}
                    noDataText={"Nessun dato"}
                    loadingText={"Caricamento in corso"}
                    loading={false}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const data = {
    data: get(state, "trasferimenti.data", []),
    //articoli: get(state, "trasferimenti.articoli", []),
    loading: get(state, "trasferimenti.loading", false),
  };

  if (data.data === null) data.data = [];
  //if (data.articoli === null) data.articoli = [];


  return data;
};

export default connect(mapStateToProps, () => ({}))(TrasferimentiComponent);
